import { CHIAVE_MODES, DitronPrinterCommand } from "./ditron-protocol-schema";

export const DITRON_SYSTEM_CMDS = {
    START_CMD: [
        { type: 'COMMAND', instruction: 'CLEAR' },
        { type: 'COMMAND', instruction: 'RESPRN' }
    ] as DitronPrinterCommand[],

    START_SALE_CMD: [
        { type: 'COMMAND', instruction: 'WECLOCK' },
        { type: 'COMMAND', instruction: 'CLEAR' },
        { type: 'COMMAND', instruction: 'RESPRN' },
        { type: 'COMMAND', instruction: 'CHIAVE',
            operands: { MODE: CHIAVE_MODES.REG }
        }
    ] as DitronPrinterCommand[],

    END_CMD: [
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    END_SALE_CMD: [
        { type: "COMMAND", instruction: "INFO",
            operands: { CODICE: 1 },
        },
        { type: "COMMAND", instruction: "INFO",
            operands: { CODICE: 7 },
        },
        { type: "COMMAND", instruction: "INFO",
            operands: { CODICE: 10 },
        },
        { type: "COMMAND", instruction: "WECUNLOCK" },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    END_SALE_VOID_CMD: [
        { type: "COMMAND", instruction: "WECUNLOCK" },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    START_LOTTERY_CODE: [
        { type: "COMMAND", instruction: "INP",
            operands: { TERM: 167 }
        }
    ] as DitronPrinterCommand[],

    GET_PRINTER_STATUS: [
        { type: "COMMAND", instruction: "CLEAR" },
        { type: "COMMAND", instruction: "RESPRN" },
        { type: "COMMAND", instruction: "INFO",
            operands: { CODICE: 19 },
        },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],
    
    GET_PRINTER_INFO: [
        { type: "COMMAND", instruction: "CLEAR" },
        { type: "COMMAND", instruction: "RESPRN" },
        { type: "COMMAND", instruction: "INFO",
            operands: { CODICE: 1 },
        },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    GET_CONFIG_RT: [
        { type: "COMMAND", instruction: "CLEAR" },
        { type: "COMMAND", instruction: "RESPRN" },
        { type: "COMMAND", instruction: "LEGGI",
            operands: { NF: 1, FILE: '/QSPI/CONFIG' }
        },
        { type: "COMMAND", instruction: "LEGGI",
            operands: { NF: 3, FILE: '/QSPI/CONFIG', APPEND:'' }
        },
        { type: "COMMAND", instruction: "LEGGI",
            operands: { NF: 4, FILE: '/QSPI/CONFIG', APPEND:'' }
        },
        { type: "COMMAND", instruction: "WECDOWNLOAD",
            operands: { PATH: '/QSPI/CONFIG' }
        },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    START_PROG_CMD: [
        { type: 'COMMAND', instruction: "CLEAR"},
        { type: 'COMMAND', instruction: "RESPRN"},
        // { type: 'COMMAND', instruction: "AZZGIO",
        //     operands: { TIPO: 1 }
        // },
        { type: 'COMMAND', instruction: "PROG"},
    ] as DitronPrinterCommand[],

    END_PROG_CMD: [
        { type: "COMMAND", instruction: "FINEPROG" },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    AZZ_GIO_CMD: [
        { type: 'COMMAND', instruction: "CLEAR"},
        { type: 'COMMAND', instruction: "RESPRN"},
        { type: 'COMMAND', instruction: "AZZGIO",
            operands: { TIPO: '2' }
        },
        { type: 'COMMAND', instruction: "WECFINE"},
    ] as DitronPrinterCommand[],

    REA_GIO_CMD: [
        { type: 'COMMAND', instruction: "CLEAR"},
        { type: 'COMMAND', instruction: "RESPRN"},
        { type: 'COMMAND', instruction: "REPORT",
            operands: { NUM: 4 }
        },
        { type: 'COMMAND', instruction: "WECFINE"},
    ] as DitronPrinterCommand[],

    START_ALLEG: [{
        type: "COMMAND", instruction: "INP",
            operands: { TERM: 178 }
        }
    ] as DitronPrinterCommand[],

    START_CUSTOMER: [{
        type: "COMMAND", instruction: "INP",
            operands: { TERM: 61 }
        }
    ] as DitronPrinterCommand[],

    START_PRINT_ALLEG: [{
        type: "COMMAND", instruction: "ALLEG",
            operands: { ON: '' }
        }
    ] as DitronPrinterCommand[],

    END_PRINT_ALLEG: [
        { type: 'COMMAND', instruction: "ALLEG",
            operands: { FINE: '' }
        },
        { type: "COMMAND", instruction: "INP",
            operands: { TERM: 179 }
        }
    ] as DitronPrinterCommand[],

    MATRICOLA_RT: [
        { type: 'COMMAND', instruction: 'CLEAR' },
        { type: 'COMMAND', instruction: 'RESPRN' },
        { type: 'COMMAND', instruction: 'DIRECTIO',
            operands: { CMD: 498, DATA: 'DATAITEMINTERNAL=92;'}
        },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[],

    START_NON_FISCAL_DOC: [
        { type: "COMMAND", instruction: "NOFIS",
            operands: { APRI: '' }
        }
    ] as DitronPrinterCommand[],

    END_NON_FISCAL_DOC: [
        { type: "COMMAND", instruction: "NOFIS",
            operands: { CHIUDI: '' }
        }
    ] as DitronPrinterCommand[],

    OPEN_CASH_DRAWER: [
        { type: 'COMMAND', instruction: 'CLEAR' },
        { type: 'COMMAND', instruction: 'RESPRN' },
        { type: "COMMAND", instruction: "INP",
            operands: { TERM: 37 }
        },
        { type: "COMMAND", instruction: "WECFINE" }
    ] as DitronPrinterCommand[]
};